import { store } from "../store/index";
import { allSettings } from "../store/actions/SettingAction";

export const listAllSettings = async (filter) => {
  const result = await store.dispatch(allSettings(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
